import { FormControlProps } from '../../interfaces/FormControlProps';
import { FormConfigHelpers } from './FormConfigHelpers';

export class FormikHelpers{
    static getValue(component: React.Component<FormControlProps>, fieldName : string){
        let result = undefined;  
        const formDefinitions = component.props.formController.props.formDefinitions;
        const formValues = component.props.formController.props.formValues;
        if (formValues) {
            let isFound = false;
            component.props.formConfig.formSteps.map((formName) => {
                if (formName != component.props.formController.props.formName) {
                    if (!isFound && formValues[formName][fieldName]) {
                        let value = formValues[formName][fieldName];
                        if (value && value.value) {
                            value = value.value;
                        }
                        result = value;
                        isFound = true;
                    }
                } else {
                    // handle current form
                    if (formDefinitions[formName]) {
                        formDefinitions[formName].map((formDef : any) => {
                            if (!isFound && formDef.name == fieldName) {
                                // get data from current form values instead of from store
                                result = component.props.formikBag.values[fieldName];
                                isFound = true;
                            }
                        });
                    }
                }
            });            
        }
        if (result === undefined) {    
            result = component.props.formikBag.values[fieldName];
        }

        return result;
    }
    static getValid(component: React.Component<FormControlProps>, fieldName : string){
        return component.props.formikBag.values[fieldName];
    }
    static mapValuesToFields(component: React.Component<FormControlProps>, data : any){
        if (data) {
            // Fill fields with data
            FormConfigHelpers.outputMappings(component, (fieldMapping: any) => {
                component.props.formikBag.setFieldValue(
                    fieldMapping.mapsTo,
                    data[fieldMapping.field]
                );

                if (data[fieldMapping.field] != '' && data[fieldMapping.field] != null) {
                    component.props.formikBag.setFieldValue(
                        'error-' + fieldMapping.mapsTo,
                        false
                    );
                } else {
                    component.props.formikBag.setFieldValue(
                        fieldMapping.mapsTo,
                        ""
                    );
                    
                    component.props.formikBag.setFieldValue(
                        'error-' + fieldMapping.mapsTo,
                        true
                    );
                }
            });
        } else {
            // Error
            FormConfigHelpers.outputMappings(component, (fieldMapping: any) => {
                component.props.formikBag.setFieldValue(
                    'error-' + fieldMapping.mapsTo,
                    true
                );
            });
        }
    }
    static mapEmptyToFields(component: React.Component<FormControlProps>, fieldError: boolean = false){
        FormConfigHelpers.outputMappings(component, (fieldMapping: any) => {
            component.props.formikBag.setFieldValue(fieldMapping.mapsTo, '');
            component.props.formikBag.setFieldValue(
                'error-' + fieldMapping.mapsTo,
                fieldError
            );
        });
    }
}